import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Shared LabOS Firebase project — DO NOT change this.
// Auth is shared across all LabOS sub-apps.
const firebaseConfig = {
  apiKey: 'AIzaSyA2sBB2hVW_NE-PtvzeMi2AN878C9q6zVk',
  authDomain: 'gcp-virtual-production-lab.firebaseapp.com',
  projectId: 'gcp-virtual-production-lab',
  storageBucket: 'gcp-virtual-production-lab.firebasestorage.app',
  messagingSenderId: '341316871807',
  appId: '1:341316871807:web:ddc00a90fed154bc4e414a',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, 'aiclobjectreplacement');
export const storage = getStorage(app);
export const functions = getFunctions(app);
